import React, { Component } from "react";
import { MDBProgress } from "mdbreact";

class LiveDashboardCounter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeLeft: props.duration, // duration in seconds
      remainingTimeData: props.remaining_time_data, // duration in seconds
    };
  }

  componentDidMount() {
    this.startCountdown();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  startCountdown = () => {
    this.timer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timeLeft <= 1) {
          clearInterval(this.timer);
          return { timeLeft: 0 };
        }
        return { timeLeft: prevState.timeLeft - 1 };
      });
    }, 1000);
  };

  formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  render() {
    return (
      <>
        <p>
          {/* <MDBProgress
            width={`${parseInt(
              100 - this.state.remainingTimeData.percentage_remaining
            )}%`}
            value={`${parseInt(
              100 - this.state.remainingTimeData.percentage_remaining
            )}%`}
            animated
          /> */}
          {this.state.remainingTimeData.is_current_booking && (
            <MDBProgress
              value={100 - this.state.remainingTimeData.percentage_remaining}
              animated
            />
          )}
        </p>
        <h3>{this.formatTime(this.state.timeLeft)}</h3>
      </>
    );
  }
}

export default LiveDashboardCounter;
